// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { BankPositionAssetType } from '@client/banks/types/position';
import type { TFunction } from 'i18next';

const BANK_POSITION_ASSET_TYPE_GLOSSARY_KEYS: Record<
  BankPositionAssetType,
  string
> = {
  [BankPositionAssetType.Stock]: 'glossary.stock',
  [BankPositionAssetType.Etf]: 'glossary.etf',
  [BankPositionAssetType.MutualFund]: 'glossary.mutual-fund',
  [BankPositionAssetType.Other]: 'glossary.other',
};

export const getBankPositionAssetTypeLabel = (
  assetType: BankPositionAssetType,
  t: TFunction,
): string =>
  t(BANK_POSITION_ASSET_TYPE_GLOSSARY_KEYS[assetType], { ns: 'glossary' });

export const getBankPositionAssetTypeOptions = (t: TFunction) =>
  Object.values(BankPositionAssetType).map(value => ({
    value,
    label: getBankPositionAssetTypeLabel(value, t),
  }));
